import { Record } from 'immutable';

import { SharePermission } from './SharePermission';

class ShareParticipant extends Record(
  {
    id: null,
    userId: null,
    shareId: null,
    createdAt: null,
    createdBy: null,
    updatedAt: null,
    updatedBy: null,
    deletedAt: null,
    deletedBy: null
  },
  'ShareParticipant'
) {
  constructor(props) {
    super({
      ...props,
      permission: new SharePermission(props.permission)
    });
  }

  get action() {
    return this.permission.action;
  }
}

export { ShareParticipant };
